/**
 * Runtime feature flags.
 *
 * Flags are sourced from EXPO_PUBLIC_* env values (the same mechanism api.ts uses
 * for EXPO_PUBLIC_API_URL, injected into .env by the Dockerfile build). They are
 * read at module-eval time and are static for the life of the app session.
 *
 * Anything gated here defaults to OFF so a half-built or staged feature can ship
 * in the bundle without affecting live drivers until the env value is set.
 */


/**
 * Driver pre-dispatch checklist — the gated flow a driver must clear before
 * heading out, the three Job Details additions, and the app-open blocking popup.
 *
 * LIVE for all jobs (2026-06-15). This is hardcoded ON because the project's
 * `expo export:web` build does NOT inline EXPO_PUBLIC_* env vars into the web
 * bundle (the API URL is patched post-build via sed in deploy-do.sh, not env
 * inlining) — so EXPO_PUBLIC_PREDISPATCH_ENABLED always resolved to false at
 * runtime and the feature shipped dormant. The REAL kill switch is the backend
 * env PREDISPATCH_CHECKLIST_ENABLED: it gates the en-route enforcement, the SMS,
 * AND the GET /jobs/:id/predispatch config (404 when off), so when the backend is
 * disabled the app-open popup / deep-link no-op even though this is true.
 */
export const PREDISPATCH_ENABLED = true;
